

export function useRoleParser() {
    return {
        parseRoles: function parse(source: number, roles: string[]): boolean[] {
        const flags: boolean[] = [];
        let flag = 1;
    
        while (source > 0) {
            if ((source & 1) === 1) {
                flags.push(true);
            }
            else {
                flags.push(false);
            }
            source >>= 1;
            flag <<= 1;
        }
    
        return flags;
    },
    roles: ["Read", "Write", "OAuth", "Admin", "", "", "Root"]
    };
}